export default __webpack_public_path__ + "static/meta-img-764ac45ebaae798a24f3d608b221e61a.png";